<template>
  
            <slide-x-right-transition :duration='800' v-show="show">
          
                <div class="container">
                    <h2 class="titulo-home">
                        NOSOTROS
                    </h2>
                    
                    <p class="parrafo-home ">
                        Somos una empresa caleña con 15 años de experiencia en la industria gráfica, dedicada a diseñar y desarrollar los empaques y piezas gráficas de nuestros clientes brindandoles la mejor asesoria y calidad en nuestros productos
                    </p>

                       
                </div>
            </slide-x-right-transition>

    
</template>

<script>

    import { mapState, mapMutations } from 'vuex'

    import {
        SlideXRightTransition,
        SlideXLeftTransition,
        SlideYUpTransition
    } from 'vue2-transitions'

    export default {
        components: {
            SlideXRightTransition,
            SlideXLeftTransition,
            SlideYUpTransition
        },
        computed: {
            ...mapState(['productsInCart','price'])
        },
        name:'nosotros',
        data() {
            return {show:true,random:0}
        },
        methods: {
           ...mapMutations(['removeFromCart','changeQuantity']),
           getPrice() {
               var price = 0
               this.productsInCart.map((x) => {
                   return price += (x.price * x.wanted)
               })
              this.$store.commit('updatePrice',[price,this.random])
               return price
           },
           getShipping() {
               this.random = Math.floor(Math.random() * (100 - 1)) + 1
           }
        },
        created(){
            this.getShipping()
        }
        
    }
</script>

<style>
/* .checkout-inner{
    height:60vh;
} */
</style>